import { render, staticRenderFns } from "./ImageClaimFileCard.vue?vue&type=template&id=49965a3c&scoped=true"
import script from "./ImageClaimFileCard.vue?vue&type=script&lang=js"
export * from "./ImageClaimFileCard.vue?vue&type=script&lang=js"
import style0 from "./ImageClaimFileCard.vue?vue&type=style&index=0&id=49965a3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49965a3c",
  null
  
)

export default component.exports